import { Container, Navbar, Nav, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-scroll";
import "./Header.css";
import logoImg from "../assets/img/portfolio-logo.png";
import { useState } from "react";

export const Header = ({ contentData }) => {
  const [fix, setFix] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [showQuestions, setShowQuestions] = useState(true);
  const [loading, setLoading] = useState(false);

  function handleFixed() {
    if (window.scrollY > 10) {
      setFix(true);
    } else {
      setFix(false);
    }
  }

  window.addEventListener("scroll", handleFixed);

  const quickQuestions = [
    "What is Anthony's work experience?",
    "What technologies does Anthony work with?",
    "What projects has Anthony worked on?",
    "Tell me about Anthony's career journey?",
  ];

  const sendMessage = async (text = message) => {
    console.log(text);
    const prompt = text.trim();

    if (!prompt) return;

    const userMessage = { role: "user", content: prompt };
    const newMessages = [...messages, userMessage];
    setMessages(newMessages);
    setMessage("");
    setShowQuestions(false);
    setLoading(true);

    try {
      const res = await fetch("http://localhost:5000/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message: prompt }),
      });

      const data = await res.json();
      const assistantMessage = { role: "assistant", content: data.content };
      setMessages([...newMessages, assistantMessage]);
    } catch (error) {
      console.error("Error sending message:", error);
      const errorMessage = {
        role: "assistant",
        content: "Sorry, something went wrong.",
      };
      setMessages([...newMessages, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     sendMessage();
  //   }
  // };

  return (
    <div className="header-container" id="header">
      <Navbar expand="lg" className={fix ? "fixed bg-dark" : ""}>
        <Container>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse className="text-center" id="navbarScroll">
            <Nav className="m-auto">
              <Link
                className="nav-link"
                to="header"
                spy={false}
                smooth={true}
                offset={0}
                duration={500}
              >
                Home
              </Link>
              <Link
                className="nav-link"
                to="about"
                spy={false}
                smooth={true}
                offset={-50}
                duration={500}
              >
                About
              </Link>
              <Link
                className="nav-link"
                to="projects"
                spy={false}
                smooth={true}
                offset={-50}
                duration={500}
              >
                Project
              </Link>
              <Link
                className="nav-link"
                to="contact"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                Contact
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container>
        <Row className="header-content text-center pt-5 pt-lg-0 align-items-lg-center pb-5">
          <Col xs={12} lg={4} className="header-content-col">
            <div>
              <Image className="logo" src={logoImg} />
            </div>
            <h1 className="esd-font header-name">{contentData.name}</h1>
            <p>
              I am an {contentData.role}. {contentData.roleDescription}.
            </p>
            <hr />
            <div>
              {contentData.socialLinks.map((link, index) => (
                <a
                  className="social-icons"
                  target="_blank"
                  rel="noreferrer"
                  href={link.url}
                  key={index}
                >
                  <i className={link.className}></i>
                </a>
              ))}
            </div>
          </Col>
          <Col xs={4} className="floating-img-col">
            <div>{/* <Image className="logo" src={logoImg} /> */}</div>
          </Col>

          <Col xs={4} className="ai-chat-container-col">
            <div className="ai-chat-container">
              <p className="chat-p-1">Chat with AM - AI Portfolio Assistant</p>
              <hr />
              {showQuestions && (
                <div className="question-grid-container">
                  <p>👋 Welcome to Anthony's Portfolio!</p>
                  <div className="question-grid">
                    {quickQuestions.map((q, idx) => (
                      <button
                        key={idx}
                        type="button"
                        className="question-box"
                        onClick={() => sendMessage(q)}
                      >
                        {q}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              <div className="chat-messages">
                {messages.map((msg, index) => (
                  <div key={index} className={`chat-message  ${msg.role}`}>
                    <p className="chat-p-2 mb-p-0">{msg.content}</p>
                  </div>
                ))}

                {( loading && <div className="chat-message assistant">
                  <p className="chat-p-2 mb-p-0">
                    <span
                      className="spinner-border spinner-border-sm"
                      style={{ color: "#000" }}
                      role="status"
                    >
                      {/* <span className="sr-only text-start">Loading...</span> */}
                    </span>{" "}
                    &nbsp; Typing...
                  </p>
                </div>)}
              </div>
              <div className="chat-input">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Ask me anything about Anthony - his experience, skills or anything else!"
                />
                <button
                  className="btn btn-sm bg-white rounded-0"
                  onClick={() => sendMessage(message)}
                >
                  <i className="bi bi-send"></i>
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
